import { render, staticRenderFns } from "./OtherBookings.vue?vue&type=template&id=35986d15&scoped=true&"
import script from "./OtherBookings.vue?vue&type=script&lang=ts&"
export * from "./OtherBookings.vue?vue&type=script&lang=ts&"
import style0 from "./OtherBookings.vue?vue&type=style&index=0&id=35986d15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35986d15",
  null
  
)

export default component.exports